import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
// import Parser from 'html-react-parser';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import useToggle from '../../../../Hooks/useToggle';
import BackToTop from '../../../BackToTop';
import Footer from '../../../Helper/FooterInstitute';
import Drawer from '../../../Mobile/DrawerInstitute';
// import Header from '../Helper/Header';
import HeaderInstructor from '../../InstructorIndex_Insti';
import { AllLanguages, BASEAPIURL, uploadFileAPI } from '../../../../config';
import {
    RegFrmRateVidMkInstr,
    RegFrmExiAudiInstr,
    RegFrmTeachDoneInstr,
    RegFrmValues2StdInstr,
    RegFrmCrsComInstr,
    RegFrmDocstaHelpInstr,
} from '../../../../masterdata';
import '../../instructor.css';

const serialize = require('form-serialize');

function InstructorRegister() {
    // const [file, setFile] = useState();
    // const [fileName, setFileName] = useState('');
    const [step1, setStep1] = useState('active');
    const [step2, setStep2] = useState('');
    const [step3, setStep3] = useState('');
    const [drawer, drawerAction] = useToggle(false);
    const [PerDetDiv, setPerDetDiv] = useState('block');
    const [AddiDet1Div, setAddiDet1Div] = useState('None');
    const [AddiDet2Div, setAddiDet2Div] = useState('None');
    const [ConfirmationDiv, setConfirmationDiv] = useState('None');
    const [PhoneNumber, setPhoneNumberTemp] = useState('');
    async function setPhoneNumber(v) {
        setMobileAready('');
        if (!v) {
            setMsgcolor('red');
            setMobileAready('Phone Number is Required.');
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Phone Number is Required.'
            });
            setProfileData({ ...profileData, sendOTP: false, sentOTP: false });
            return false;
        }
        setResMessage({ ...resMessage, status: 0, value: ""});
        setPhoneNumberTemp(v);
        setProfileData({ ...profileData, sendOTP: true, sentOTP: false });
        return true;
    }
    const [InstrName, setInstrName] = useState('');
    const [InstrEmail, setInstrEmailTemp] = useState('');
    async function setInstrEmail(v) {
        setEmailAready('');
        if (v.trim() === '') {
            setMsgcolor('red');
            setEmailAready('Email is Required.');
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Email is Required.'
            });
            setProfileData({ ...profileData, sendEOtp: false, sentEOtp: false, emailVerify: false });
            return false;
        }
        if (/\S+@\S+\.\S+/.test(v)) {
            // console.log('Valid Email');
            setProfileData({ ...profileData, sendEOtp: true, sentEOtp: false, emailVerify: false });
        } else {
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Please enter an valid Email.'
            });
            setProfileData({ ...profileData, sendEOtp: false, sentEOtp: false, emailVerify: false });
            setEmailAready('Please enter an valid Email.');
            return false;
        }
        setInstrEmailTemp(v);
        return true;
    }
    const [CVfile, setCVfile] = useState();
    const [Msgcolor, setMsgcolor] = useState();
    
    const [APIMessage, setMessage] = useState();
    const [MobileAready, setMobileAready] = useState('');
    const [EmailAready, setEmailAready] = useState('');
    const [classforform, setclassforform] = useState('col-md-7');
    const [resMessage, setResMessage] = useState({ status: 0, value: '' });
    const [profileData, setProfileData] = useState({
        mobileVerify: false,
        emailVerify: false,
        sendOTP: false,
        sendEOtp: false,
        mOtp: '',
        eOtp: '',
        sentOTP: false,
        sentEOtp: false,
    });
    const form = document.querySelector('#Inst-Regi-Form');
    const obj = serialize(form, { hash: true, empty: true });

    async function ShowFormDiv(type) {
        let AllOkay = 1;
        if (MobileAready.trim() !== '') {
            AllOkay = 0;
             setResMessage({
                ...resMessage,
                status: 0,
                value: MobileAready
            });
        }
        if (EmailAready.trim() !== '') {
            AllOkay = 0;
            setResMessage({
                ...resMessage,
                status: 0,
                value: EmailAready
            });
        }
        if (InstrName.trim() === '') {
            setMsgcolor('red');
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Name is Required.'
            });
            AllOkay = 0;
            return false;
        }
        if (PhoneNumber === '') {
            AllOkay = 0;
             setResMessage({
                ...resMessage,
                status: 0,
                value: 'Phone Number is Required.'
            });
            setMobileAready('Phone Number is Required.');
            return false;
        }

        if (InstrEmail.trim() === '') {
            AllOkay = 0;
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Email is Required 1.'
            });
            setEmailAready('Email is Required.');
            return false;
        }
        if (/\S+@\S+\.\S+/.test(InstrEmail)) {
            // console.log('Valid Email');
        } else {
            AllOkay = 0;
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Please enter an valid Email.'
            });
            setEmailAready("Please enter an valid Email.");
            return false;
        }
        if (!profileData.sentOTP) {
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Please verify your mobile by clicking Send OTP.'
            });
            return false;
        }
        
        if (!profileData.sentEOtp) {
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Please verify your Email by clicking Send email OTP.'
            });
            return false;
        }
        if (!profileData.mobileVerify) {
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Please verify your mobile to continue.'
            });
            return false;
        }
        if (!profileData.emailVerify) {
            setResMessage({
                ...resMessage,
                status: 0,
                value: 'Please verify your email to continue.'
            });
            return false;
        }

        if (AllOkay === 1) {
            setPerDetDiv('none');
            setAddiDet1Div('none');
            setAddiDet2Div('none');
            setConfirmationDiv('none');
            setclassforform('col-md-7');
            setStep1(' ');
            setStep2(' ');
            setStep3(' ');
            switch (type) {
                case 'addi2':
                    setStep2('active');
                    setAddiDet2Div('block');
                    break;
                case 'addi1':
                    setStep2('active');
                    setAddiDet1Div('block');
                    break;
                case 'confirm':
                    setStep3('active');
                    setclassforform('col-md-12 text-center');
                    setConfirmationDiv('block');
                    break;
                default:
                    setStep1('active');
                    setPerDetDiv('block');
                    break;
            }
        }
    }

    // for file uploade will be here
    async function uploadFile(e, file) {
        e.preventDefault();
        setMessage("Uploading Document...");
        // return false;
        try {
            const data = await uploadFileAPI(file, 'instructorDocument');
            if (data && data.file && data.file !== 0) {
                setCVfile(data.file);
                setMessage('');
            } else {
                alert(data.message);
                setMessage('');
            }
        } catch (ex) {
            alert(ex.message);
                setMessage('');
        }
    }
    // for file uploade will be here

    const [showMElement, setShowMElement] = useState(true);
    const handleClickSend = () => {
        setShowMElement(false); // Optional: reset if clicked again
        setTimeout(() => {
            setShowMElement(true);
        }, 3000); // 1 second = 1000 milliseconds
    };

    // for sending the OTP message to Mobile
    async function sentOtpMessage(mobileno) {
        handleClickSend();
        setResMessage({ ...resMessage, value: '' });
        if (mobileno) {
            // all goood to go
        } else {
            setResMessage({ ...resMessage, status: 0, value: 'Mobile is required.' });
            return false;
        }
        setProfileData({ ...profileData, sentOTP: false });
        const cleanMobileNo = mobileno.replace(/\s+/g, ''); // removes all spaces
        let returntype = false;
        try {
            const url = `${BASEAPIURL}/admin/instructure/sentOtpMessage`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            await axios.post(url, { mobile: cleanMobileNo }, config).then((response) => {
                setProfileData({
                    ...profileData,
                    // sendOTP: response.data.status === 1,
                    sentOTP: response.data.status === 1,
                    otp_id: response.data.data && response.data.data.otp_id ? response.data.data.otp_id : 0
                });
                setResMessage({
                    ...resMessage,
                    status: response.data.status ? 1 : 0,
                    value: response.data.status ? '' : response.data.message
                });
            });
        } catch (err) {
            console.log(err);
             setResMessage({
                ...resMessage,
                status: 0,
                value: err.message
            });
        }
        return returntype;
    }

    // for the mobile Verification API
   

    async function verifyOtpMessage() {
        const mobileno = PhoneNumber.replace(/\s+/g, ''); // removes all spaces
        const otp_id = profileData.otp_id;
        if (mobileno) {
            // all goood to go
        } else {
            setResMessage({ ...resMessage, status: 0, value: 'Please Enter your mobile no again.' });
            return false;
        }
        const cleanMobileNo = mobileno.replace(/\s+/g, ''); // removes all spaces
        let returntype = false;
        try {
            const url = `${BASEAPIURL}/admin/instructure/verifyOtpMessage`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            axios.post(url, {
                mobile: cleanMobileNo,
                otp_id,
                otp: profileData.mOtp
            }, config).then((response) => {
                setProfileData({
                    ...profileData,
                    mobileVerify: response.data.status===1
                });
                if (!response.data.status) {
                    setResMessage({ ...resMessage, status: 0, value: response.data.message });    
                }
            });
        } catch (err) {
            setResMessage({ ...resMessage, status: 0, value: err.message });
        }
        return returntype;
    }
    // for the mobile Verification API
    const random = Math.floor(1000 + Math.random() * 9000); // 4-digit
    const [emailOTP, setEmailOTP] = useState(random); // 4-digit
    
    const [showEElement, setshowEElement] = useState(true);
    const handleClickSendEmail = () => {
        setshowEElement(false); // Optional: reset if clicked again
        setTimeout(() => {
            setshowEElement(true);
        }, 3000); // 1 second = 1000 milliseconds
    };
    async function sendOtpEmail(email) {
          const random = Math.floor(1000 + Math.random() * 9000); // 4-digit
          setEmailOTP(random); // 4-digit
        handleClickSendEmail();
        setProfileData({ ...profileData, sentEOtp: false, sendEOtp: false});
        setResMessage({ ...resMessage, value: '' });
        if (email) {
            // all goood to go
        } else {
            setResMessage({ ...resMessage, status: 0, value: 'Email is required.' });
            return false;
        }
        let returntype = false;
        try {
            const url = `${BASEAPIURL}/admin/instructure/sendOtpEmail`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            await axios.post(url, { email, otp: random, name: InstrName }, config).then((response) => {
                setResMessage({
                    ...resMessage,
                    status: response.data.status ? 1 : 0,
                    value: response.data.status ? '' : response.data.message
                });
                setProfileData({
                    ...profileData,
                    sendEOtp: response.data.status !== 1,
                    sentEOtp: response.data.status === 1
                });
            });
        } catch (err) {
            setResMessage({
                ...resMessage,
                status: 0,
                value: err.message
            });
            setProfileData({ ...profileData, sentEOtp: false, sendEOtp: true});
        }
        return returntype;
    }

    async function checkEmailAready(emailid) {
        let returntype = false;
        try {
            // console.log(BASEAPIURL);
            const url = `${BASEAPIURL}/admin/instructure/checkifalreadyemail`;
            const formData = new FormData();
            formData.append('emailid', emailid);
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
            };
            axios.post(url, formData, config).then((response) => {
                // const response = resJson.json();
                console.log(response.data.message);
                console.log(response.data);
                if (response.data.status === 1) {
                    setMsgcolor('red');
                    setEmailAready(response.data.message.toString());
                    setResMessage({ ...resMessage, status: 0, value: response.data.message.toString() });
                    // ShowFormDiv('personal');
                    returntype = true;
                } else {
                    setEmailAready('');
                }
            });
        } catch (err) {
            setMsgcolor('red');
            console.log(err);
            setEmailAready('Something went wrong, Please try again later.');
             setResMessage({
                ...resMessage,
                status: 0,
                value: err.message
            });
        }
        return returntype;
    }

    async function RegistrerInstructor() {
        try {
            setMsgcolor('green');
            const url = `${BASEAPIURL}/admin/instructure/signup`;
            // const url = 'https://ktuniexpo.com/women-directors/test.php';
            const formData = new FormData();
            formData.append('edit', 0);
            // get all the data and add there
            formData.append('CVfile', CVfile);
            // Object.keys(obj).map(function(key) {
            Object.keys(obj).map((index) => {
                // formData.append(index, value); // console.log(index); console.log(obj[index]);
                formData.append(index, obj[index]);
                return index;
            });

            formData.append('mobileVerify', profileData.mobileVerify);
            formData.append('emailVerify', profileData.emailVerify);
            formData.append('eOtp', profileData.eOtp);
            formData.append('mOtp', profileData.mOtp);

            const config = {
                headers: {
                    'content-type': 'application/json', // multipart/form-data
                },
            };
            axios.post(url, formData, config).then((response) => {
                setMessage(response.data.message);
                setResMessage({ ...resMessage, status: response.data.status, value: response.data.message });
            });
        } catch (err) {
            setMsgcolor('red');
            console.log(err);
            setMessage('Something went wrong, Please try again later.');
            setResMessage({ ...resMessage, status: 0, value: "Something went wrong, Please try again later." });
        }
    }

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderInstructor drawer={drawer} action={drawerAction.toggle} />
            <>
                <div className="container pt-4 pb-4">
                    <div
                        className="p-3 text-center"
                        style={{
                            background: `url(assets/img/instructor/headerbg.jpg)`,
                            backgroundRepeat: 'repeat',
                            backgroundSize: '100%',
                        }}
                    >
                        <h2 className="m-3 text-white">Become an Instructor</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-1"></div>

                        <div className="col-md-10">
                            <div className="mt-4 mb-4 ry_instr_shadow">
                                <div className="instr_signup_head d-none d-md-block">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <h2 className={`instr_signup_head_step ${step1}`}>1</h2>
                                        </div>
                                        <div className="col-md-4">
                                            <h2 className={`instr_signup_head_step ${step2}`}>2</h2>
                                        </div>
                                        <div className="col-md-4">
                                            <h2 className={`instr_signup_head_step ${step3}`}>3</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row align-items-center">
                                    <div className={classforform}>
                                        <form
                                            id="Inst-Regi-Form"
                                            encType="multipart/form-data"
                                            className="m-4 p-4"
                                            style={{ display: 'block' }}
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                RegistrerInstructor();
                                            }}
                                        >
                                            <div className="For_Form_title"></div>

                                            <div style={{ display: ConfirmationDiv }}>
                                                <img
                                                    src="assets/img/instructor/inst_reg_done.jpg"
                                                    alt="Acumen Glow"
                                                    style={{ maxWidth: '100%' }}
                                                    className="mt-1 mb-4"
                                                />
                                                <h3 className="mt-3">
                                                    Your request has been submitted successfully.
                                                </h3>
                                                <div
                                                    className="message mt-3"
                                                    style={{ color: Msgcolor }}
                                                >
                                                    {APIMessage ? <span>{APIMessage}</span> : ''}
                                                </div>
                                            </div>

                                            <div style={{ display: PerDetDiv }}>
                                                <h4 className="mb-2">Personal Details</h4>
                                                <div className="form-group">
                                                    <label className="ry_label">Name</label>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        className="form-control"
                                                        placeholder="Enter Your Full Name"
                                                        onKeyUp={(e) => {
                                                            setInstrName(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        Course Category
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="coursecati"
                                                        className="form-control"
                                                        placeholder="Enter which category is your course in"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        Upload Document/ CV
                                                    </label>
                                                    <input
                                                        type="file"
                                                        name="cvfile"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            // saveFile(e);
                                                            if (e.target.files && e.target.files.length > 0) {
                                                                // uploadFile(e, e.target.files[0].name);
                                                                uploadFile(e, e.target.files[0], e.target.files[0].name);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">Youtube Link</label>
                                                    <input
                                                        type="text"
                                                        name="youtube"
                                                        className="form-control"
                                                        placeholder="Enter Youtube Link"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        Linkedin Link
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="linkedin"
                                                        className="form-control"
                                                        placeholder="Enter Linkedin Link"
                                                    />
                                                </div>
                                                <div className="form-group" style={{ position: 'relative' }}>
                                                    <label className="ry_label">Phone Number</label>
                                                    <PhoneInput
                                                        required
                                                        international
                                                        className="form-control"
                                                        name="phonenumber"
                                                        value={PhoneNumber}
                                                        onChange={(value) => {
                                                            setPhoneNumber(value);
                                                        }}
                                                        defaultCountry="AE"
                                                        style={{ position: 'relative' }}
                                                    />
                                                    {profileData.sendOTP && !profileData.sentOTP && (
                                                        <a
                                                            style={{
                                                                position: 'absolute',
                                                                color: '#cc0000',
                                                                top: '30px',
                                                                right: '10px',
                                                                zIndex: 999999,
                                                            }}
                                                            href="/"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (showMElement) {
                                                                    sentOtpMessage(PhoneNumber);
                                                                }
                                                            }}
                                                        >
                                                            {showMElement ? 'Send OTP' : 'Sending'}
                                                        </a>
                                                    )}
                                                    {profileData.mobileVerify && (
                                                        <a
                                                            className="text-success"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '30px',
                                                                right: '10px',
                                                                zIndex: 999999,
                                                            }}
                                                        >
                                                            Verified
                                                        </a>
                                                    )}
                                                    <div
                                                        className="message d-none"
                                                        style={{ color: Msgcolor }}
                                                    >
                                                        {MobileAready ? (
                                                            <span>{MobileAready}</span>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </div>

                                                {/* {profileData.sendOTP ? 'sahi' : 'galat'}
                                                #
                                                {profileData.sentOTP ? 'sahi' : 'galat'}
                                                #
                                                {profileData.mobileVerify ? 'sahi' : 'galat'}

                                                <br />
                                                {profileData.sendEOtp ? 'sahi' : 'galat'} e 
                                                #
                                                {profileData.sentEOtp ? 'sahi' : 'galat'} e 
                                                #
                                                {profileData.emailVerify ? 'sahi' : 'galat'} e  */}

                                                    {!profileData.mobileVerify && profileData.sentOTP && ( 
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <div className="form-group">
                                                                    <label className="ry_label">
                                                                        Mobile OTP
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        name="mOtp"
                                                                        className="form-control"
                                                                        placeholder="Enter Mobile OTP"
                                                                        onChange={(e) => {
                                                                            setProfileData({ ...profileData, mOtp: e.target.value  });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-group">
                                                                    <label className="ry_label">&nbsp;</label>
                                                                    <br />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                        onClick={() => {
                                                                            verifyOtpMessage();
                                                                        }}
                                                                    >
                                                                        Verify
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                   

                                                
                                                

                                                <div className="form-group" style={{ position: 'relative' }}>
                                                    <label className="ry_label">Email ID</label>
                                                    <input
                                                        type="email"
                                                        name="emailid"
                                                        className="form-control"
                                                        placeholder="Enter Email ID"
                                                        onChange={(e) => {
                                                                setInstrEmail(e.target.value);
                                                                checkEmailAready(e.target.value);
                                                            }
                                                        }
                                                    />
                                                    
                                                    
                                                    {profileData.sendEOtp && !profileData.sentEOtp && (
                                                        <a
                                                            style={{
                                                                position: 'absolute',
                                                                color: '#cc0000',
                                                                top: '30px',
                                                                right: '10px',
                                                                zIndex: 999999,
                                                            }}
                                                            href="/"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                if (showEElement) {
                                                                    sendOtpEmail(InstrEmail);
                                                                }                                                                
                                                            }}
                                                        >
                                                            {showEElement ? 'Send email OTP' : 'Sending'}
                                                        </a>
                                                    )}

                                                    
                                                    {profileData.emailVerify && (
                                                        <a
                                                            className="text-success"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '30px',
                                                                right: '10px',
                                                                zIndex: 999999,
                                                            }}
                                                        >
                                                            Verified
                                                        </a>
                                                    )}

                                                    <div
                                                        className="message d-none"
                                                        style={{ color: Msgcolor }}
                                                    >
                                                        {EmailAready ? (
                                                            <span>{EmailAready}</span>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </div>

                                                
                                                
                                                    {!profileData.emailVerify && profileData.sentEOtp && (
                                                        <div className="row">
                                                            <div className="col-md-7">
                                                                <div className="form-group">
                                                                    <label className="ry_label">
                                                                        Email OTP
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        name="eOtp"
                                                                        className="form-control"
                                                                        placeholder="Enter Email OTP"
                                                                        onChange={(e) => {
                                                                            setProfileData({ ...profileData, eOtp: e.target.value });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-5">
                                                                <div className="form-group">
                                                                    <label className="ry_label">&nbsp;</label>
                                                                    <br />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                        onClick={() => {
                                                                            if (Number(emailOTP) === Number(profileData.eOtp)) {
                                                                                setResMessage({ ...resMessage, status: 0, value: "" });
                                                                                setProfileData({ ...profileData, emailVerify: true });
                                                                            } else {
                                                                                setResMessage({ ...resMessage, status: 0, value: `Please Enter the correct email reciibed on ${InstrEmail}` });
                                                                            }
                                                                        }}
                                                                    >
                                                                        Verify
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                

                <div className={`alert ${resMessage.value ? `alert-${resMessage.status === 1 ? 'success' : 'danger'}` : ''}`}>
                    {resMessage.value ? resMessage.value : <>&nbsp;</>}
                </div>

                                                <button
                                                    type="button"
                                                    className="btn btn-docsta-instructor"
                                                    onClick={() => {
                                                        ShowFormDiv('addi1');
                                                    }}
                                                >
                                                    Proceed
                                                </button>
                                            </div>

                                            <div style={{ display: AddiDet1Div }}>
                                                <h4 className="mb-2">Additional Details</h4>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        1. What language is your course in?
                                                    </label>
                                                    <select
                                                        name="language"
                                                        className="form-control"
                                                    >
                                                        <option value="">Select Language</option>
                                                        {/* {RegFrmLangInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))} */}
                                                        {AllLanguages.map((L) => (
                                                            <option value={L} key={L}>
                                                                {L}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        2. Which form of teaching have you done before?
                                                    </label>
                                                    <select
                                                        name="teachdone"
                                                        className="form-control"
                                                    >
                                                        {RegFrmTeachDoneInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        3. Where do you rate yourself regarding your video-making skills?
                                                    </label>
                                                    <select
                                                        name="vidrating"
                                                        className="form-control"
                                                    >
                                                        {RegFrmRateVidMkInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        4. Do you have an existing audience or students to share your course with?
                                                    </label>
                                                    <select name="exiaudi" className="form-control">
                                                        {RegFrmExiAudiInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        5. What set of values are you hoping to add to your ideal student's life?
                                                    </label>
                                                    <select name="val2std" className="form-control">
                                                        {RegFrmValues2StdInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn btn-docsta-instructor"
                                                    onClick={() => {
                                                        ShowFormDiv('addi2');
                                                    }}
                                                >
                                                    Proceed
                                                </button>
                                            </div>

                                            <div style={{ display: AddiDet2Div }}>
                                                <h4 className="mb-2">Additional Details</h4>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        6. What would you like to name your course?
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="namecourse"
                                                        className="form-control"
                                                        placeholder="Type Here/  Eg: Data Analyst, Learn Photoshow Etc."
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        7. Who are your target students?
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="tarstd"
                                                        className="form-control"
                                                        placeholder="Type Here/  Eg: School Students, College Students Etc."
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        8. Are there any requirements or pre-requisities for taking your course?
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="prereq"
                                                        className="form-control"
                                                        placeholder="No/ If Yes Type Here"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        9. What would you like our help with?
                                                    </label>
                                                    <select
                                                        name="docstahelp"
                                                        className="form-control"
                                                    >
                                                        {RegFrmDocstaHelpInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label className="ry_label">
                                                        10. How much of your course is currently ready?
                                                    </label>
                                                    <select
                                                        name="crsready"
                                                        className="form-control"
                                                    >
                                                        {RegFrmCrsComInstr.map((singi) => (
                                                            <option
                                                                value={Object.keys(singi)[0]}
                                                                key={Object.keys(singi)[0]}
                                                            >
                                                                {Object.values(singi)[0]}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <button
                                                    type="submit"
                                                    className="btn btn-docsta-instructor"
                                                    onClick={() => {
                                                        ShowFormDiv('confirm');
                                                    }}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-5 p-5 hideonmobile text-center">
                                        <img
                                            src="assets/img/instructor/InstrSignStep01.png"
                                            alt="Acumen Glow"
                                            style={{ display: PerDetDiv }}
                                        />
                                        <img
                                            src="assets/img/instructor/InstrSignStep02.png"
                                            alt="Acumen Glow"
                                            style={{ display: AddiDet1Div }}
                                        />
                                        <img
                                            src="assets/img/instructor/InstrSignStep03.png"
                                            alt="Acumen Glow"
                                            style={{ display: AddiDet2Div }}
                                        />
                                    </div>
                                </div>
                                <p className="text-center mt-1 d-none">
                                    Already have an account?
                                    <br />
                                    <Link to="/instructor/login" className="mb-4  mt-3">
                                        <button type="submit" className="btn btn-info">
                                            Login as Instructor
                                        </button>
                                    </Link>
                                </p>
                            </div>
                        </div>

                        <div className="col-md-1"></div>
                    </div>
                </div>
            </>
            <Footer className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default InstructorRegister;
